var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRescheduled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2159_17801",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2159_17801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.53331 14.3333C3.19998 14.3333 2.91665 14.2167 2.68331 13.9833C2.44998 13.75 2.33331 13.4667 2.33331 13.1333V4.20001C2.33331 3.86668 2.44998 3.58334 2.68331 3.35001C2.91665 3.11668 3.19998 3.00001 3.53331 3.00001H4.46665V1.58334H5.48331V3.00001H10.5333V1.58334H11.5333V3.00001H12.4666C12.8 3.00001 13.0833 3.11668 13.3166 3.35001C13.55 3.58334 13.6666 3.86668 13.6666 4.20001V8.10001H12.6666V6.86668H3.33331V13.1333C3.33331 13.1778 3.35554 13.2222 3.39998 13.2667C3.44442 13.3111 3.48887 13.3333 3.53331 13.3333H8.09998V14.3333H3.53331ZM12.6666 15.9C11.9111 15.9 11.2444 15.6667 10.6666 15.2C10.0889 14.7333 9.71109 14.1445 9.53331 13.4333H10.3666C10.5222 13.9333 10.8084 14.336 11.2253 14.6413C11.6418 14.9471 12.1222 15.1 12.6666 15.1C13.3444 15.1 13.9195 14.8638 14.392 14.3913C14.864 13.9193 15.1 13.3445 15.1 12.6667C15.1 11.9889 14.864 11.414 14.392 10.942C13.9195 10.4696 13.3444 10.2333 12.6666 10.2333C12.3 10.2333 11.9555 10.3111 11.6333 10.4667C11.3111 10.6222 11.0278 10.8333 10.7833 11.1H11.9V11.9H9.43331V9.43334H10.2333V10.5333C10.5444 10.2 10.9084 9.93334 11.3253 9.73334C11.7418 9.53334 12.1889 9.43334 12.6666 9.43334C13.5555 9.43334 14.3166 9.75001 14.95 10.3833C15.5833 11.0167 15.9 11.7778 15.9 12.6667C15.9 13.5556 15.5833 14.3167 14.95 14.95C14.3166 15.5833 13.5555 15.9 12.6666 15.9Z",
    fill: "#E24AE2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRescheduled);
export default __webpack_public_path__ + "static/media/rescheduled.ea7148a9f48c24a264dbc4c2b84b8ec4.svg";
export { ForwardRef as ReactComponent };